//@ts-ignore
import { FormLayout } from "@careinfo/layout";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import CreateIcon from "../../Icons/CreateIcon";
import {
  IAuthorSchema,
  createAuthorSchema,
} from "../../utils/validationSchema";
import CreateAuthorForm from "./AuthorForm";

const CreateAuthor = (props: any) => {
  const { handleCreate, isLoading } = props;

  const {
    register,
    handleSubmit,
    getValues,
    setError,
    setValue,
    clearErrors,
    control,
    formState: { errors },
  } = useForm<IAuthorSchema>({
    defaultValues: async () => ({
      display_name: "",
      user: "",
      preview_image: null,
      summery: "",
    }),
    resolver: yupResolver(createAuthorSchema),
  });

  return (
    <div>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Blog Author
        </span>
      </div>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleCreate}
        setError={setError}
        buttonLabel={"Create"}
        isLoading={isLoading}
      >
        <CreateAuthorForm
          register={register}
          errors={errors}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
          control={control}
        />
      </FormLayout>
    </div>
  );
};

export default CreateAuthor;
